<template>
	<div>
		<el-form>
			
			<x-form
				type="editor"
				v-model="group_brief"
			></x-form>

		</el-form>

		<div class="footer-wrapper">
			<el-button @click="cancel">取消</el-button>
			<el-button type="primary" @click="confirm">保存</el-button>
		</div>
	</div>
</template>

<script type="text/javascript">
import {
	saveGroup
} from '@/api/group';
export default {
	data() {
		return {
			group_brief: ''
		}
	},
	props: {
		close: Function,
		fetchList: Function,
		detail: Object
	},
	watch: {
		detail: {
			handler(val) {
				if (!val) return
				this.group_brief = val.group_brief
			},
			immediate: true
		}
	},
	methods: {
		cancel() {
			this.close()
		},
		confirm() {
			if (!this.group_brief) return

			saveGroup({
				id: this.detail.id,
				group_brief: this.group_brief
			}).then(res => {
				this.$emit('success')
				this.$message.success('保存成功')
				// this.cancel()
				this.fetchList()
			})
		},

	}
}
</script>

<style lang="less">
	
</style>